import React, {useEffect} from 'react';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {MemberLevel, UserApi} from '../../scaffold';
import useAuth from '../../utils/AuthContext';
import {useHistory} from 'react-router-dom';
import {Alert, Button, Card} from 'antd';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import card from '../../assets/card.png';
import moment from 'moment';
import {saveAs} from 'file-saver';
import domtoimage from 'dom-to-image';
export default function ProfileCardPage() {
  const findHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userFindGet);
  const history = useHistory();
  const auth = useAuth();
  useEffect(() => {
    if (auth.currentUser) findHook.requestSync({id: auth.currentUser?.id || 0});
  }, [auth.currentUser]);
  function download() {
    const node = document.getElementById('the-card');
    if (node) {
      domtoimage.toBlob(node).then(blob => {
        saveAs(blob, '会员证.png');
      });
    }
  }
  return (
    <AppSideLayout title={'电子会员证'}>
      <Card style={{flex: 1}} title={'电子会员证'} loading={findHook.loading}>
        {findHook.data && (
          <div>
            <div id={'export-img'} />
            {!findHook.data.memberNo && <Alert message={'您还尚未成为会员'} />}
            {findHook.data.memberNo && (
              <div style={{position: 'relative', userSelect: 'none', width: 381}} id={'the-card'}>
                <div
                  style={{
                    position: 'absolute',
                    color: 'black',
                    left: 100,
                    fontSize: 44,
                    top: 224,
                    textAlign: 'center',
                    width: 190,
                    fontFamily: 'serif',
                    fontWeight: 'bold',
                  }}>
                  {findHook.data.personalApprove?.name}
                </div>
                <div
                  style={{
                    position: 'absolute',
                    color: 'black',
                    left: 330,
                    top: 226,
                    fontWeight: 'bold',
                  }}>
                  {findHook.data.memberLevel === MemberLevel.学生会员 && (
                    <div>
                      <div style={{fontSize: 32}}>学生会员</div>
                      <div style={{fontSize: 18, marginTop: -10}}>STUDENT MEMBER</div>
                    </div>
                  )}
                  {findHook.data.memberLevel !== MemberLevel.学生会员 && (
                    <div>
                      <div style={{fontSize: 32}}>会 员</div>
                      <div style={{fontSize: 18, marginTop: -10}}>MEMBER</div>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    position: 'absolute',
                    color: '#9a97a3',
                    left: 98,
                    top: 315,
                    fontWeight: 'bold',
                    width: 400,
                    height: 30,
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: 16,
                  }}>
                  <div>NO. {findHook.data.memberNo}</div>
                  {findHook.data.memberExpiredTime?.startsWith('2099') ? (
                    <div>终身会员</div>
                  ) : (
                    <div>有效期至: {moment(findHook.data.memberExpiredTime).format('YYYY-MM-DD')}</div>
                  )}
                </div>
                <img src={card} alt="" style={{width: 600}} />
              </div>
            )}
            <Button type={'primary'} className={'m-t-20'} onClick={download}>
              下载会员证
            </Button>
          </div>
        )}
        {!auth.currentUser && <div>请先登录</div>}
      </Card>
    </AppSideLayout>
  );
}
